import { metaSchemas } from "@/lib/constants";
import LogicaAPI from "./logicaapi";

class Episodes extends LogicaAPI {
  async getEpisode(id) {
    const params = {
      ...this.dsearchCommonParams,
      condition: {
        meta_schema_id: metaSchemas.episode.id,
        meta_id: id,
        "values.adult_flag": false,
      },
    };
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params),
      },
    });
  }

  nextEpisode(id) {
    const params = {
      sort: "num",
      order: "asc",
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      datasource: "decorator",
    };
    return this.get(`/api/v1/metas/${id}/next`, { params });
  }
}

export default Episodes;
